import * as React from 'react';

const Spinner = (props) =>
{
    let loadingMessage = (props.loadingMessage) ? props.loadingMessage : 'Loading...';
    return(<div className="loading">
            <div className="sons-loader">
                <div className="sons-symbol-wrapper">
                    <div className="sons-symbol is-active is-infinite">
                        <div className="sons-symbol__container">
                            <div className="sons-symbol__part top-left"></div>
                            <div className="sons-symbol__part top-right"></div>
                            <div className="sons-symbol__part bottom-left"></div>
                            <div className="sons-symbol__part bottom-right"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Spinner;